import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Header, Icon, Anchor, Button } from 'Components/core';

import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

// Images
import LifeInsurance from './images/Life_and_Disability_-_Life_insurance.jpeg';
import ShortTerm from './images/Life_and_Disability_-_Short-term_disability.jpeg';
import LongTerm from './images/Life_and_Disability_-_Long-term_disability.jpeg';
import ResourceAdvisor from './images/Life_and_Disability_-_Resource_Advisor.jpeg';


import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import Api from 'Root/libs/analytics/Api';
import CODES from 'Root/libs/analytics/CodeDef';
import { replaceAnchor } from 'Root/libs/anchor';
import { SubHeader, TitleHeader } from 'Components/core/Header';

export default () =>{ 
  
  useEffect(()=>{
    Api.recordAcitity(CODES.MENU_LND);
  },[]);
  
  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Container
            seperation="24px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
            
            {state.lifeAndDisability?.lifeInsurance   &&
           <React.Fragment>
             <TitleHeader>Life 
                  <SubHeader>insurance and disability plans</SubHeader>

             </TitleHeader>
             <InfoBox header="Life insurance" image={LifeInsurance}>
               {state.lifeAndDisability?.lifeInsurance!==true && <p dangerouslySetInnerHTML={{__html:replaceAnchor(state.lifeAndDisability?.lifeInsurance)}}></p>}
               {state.lifeAndDisability?.lifeInsurance===true &&<React.Fragment>
                 <p>
                Life insurance is designed to pay benefits should something
                happen to you. But we go beyond just sending a benefit check.
                You’ll have access to:
                 </p>
                 <ul>
                   <li>
                     <b>Resource Advisor</b> can help you right now at no extra
                  cost. You can get help to create a will, establish a budget
                  and financial plan, cope with identity theft, manage a legal
                  issue, or get personal counseling. Grief counseling, legal and
                  financial advice, and other guidance are also available to
                  your family for six months if anything should happen to you.
                   </li>
                   <li>
                     <b>Travel assistance</b> gives you access to emergency medical
                  and travel services if you’re traveling more than 100 miles
                  from home.
                   </li>
                   <li>
                     <b>Living benefits</b> allow you to get part of your life
                  insurance benefits early if you’re terminally ill. Your
                  beneficiary may get an extra benefit if your death or certain
                  injuries are caused by an accident.
                   </li>
                   <li>
                     <b>Beneficiary support</b> can help your survivors settle your
                  estate and handle other matters when you pass away. Plus, your
                  beneficiaries can contact your Resource Advisor for grief
                  counseling, legal and financial advice, and other guidance for
                  six months should anything happen to you.
                   </li>
                 </ul>
               </React.Fragment>}
             </InfoBox>
           </React.Fragment>
            }
            {state.lifeAndDisability?.shortDisability   && (
              <InfoBox header="Short-term disability" image={ShortTerm}>
                {state.lifeAndDisability?.shortDisability!==true && <p dangerouslySetInnerHTML={{__html:replaceAnchor(state.lifeAndDisability?.shortDisability)}}></p>}
                {state.lifeAndDisability?.shortDisability===true && <p>
              If you’re not able to work because of a certain accident or illness, short-term disability benefits can help give you the financial
backup you need. We help you get back to work — and back to your life — with face-to-face and telephone counseling and other support services.

                </p>}
              </InfoBox>
            )}
            {state.lifeAndDisability?.longDisability  && (
              <InfoBox header="Long-term disability" image={LongTerm}>
                {state.lifeAndDisability?.longDisability!==true && <p dangerouslySetInnerHTML={{__html:replaceAnchor(state.lifeAndDisability?.longDisability)}}></p>}
                {state.lifeAndDisability?.longDisability===true && <p>
              If a lengthy illness or injury keeps you from work for an extended period of time, long-term disability benefits can give you peace
              of mind. We provide services to help you get back to work and improve your health, including behavioral health counseling, legal services
              and financial advice.

                </p>}
              </InfoBox>
            )}

            {state.lifeAndDisability?.resourceAdvisor  && (
              <InfoBox header="Resource Advisor" image={ResourceAdvisor}>
                <p dangerouslySetInnerHTML={{__html:replaceAnchor(state.lifeAndDisability?.resourceAdvisor)}}></p>
                
              </InfoBox>
            )}
            <ReadyToEnroll />
          </Container>
        );
      }}
    </Subscribe>
  );
};